import { Component, OnInit } from '@angular/core';
import { Settings } from '../../../../app.settings.model';
import { AppSettings } from '../../../../app.settings';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-user-activities',
  templateUrl: './user-activities.component.html',
  styleUrls: ['./user-activities.component.scss'],
  providers: [TranslatePipe]
})
export class UserActivitiesComponent implements OnInit {
  settings: Settings;
  filtration: any;
  defaultCheckboxValue: boolean = false;
  activities: any;
  constructor(public appSettings: AppSettings, public translatePipe: TranslatePipe) {
    this.settings = this.appSettings.settings;
  }

  ngOnInit() {
    this.filtration = [
      { id: 1, value: false, label: 'UserModule.UsersData.Review' },
      {
        id: 2,
        value: false,
        label: 'UserModule.UsersData.Email',
        sub: [
          { id: 2 - 1, value: false, label: 'UserModule.UsersData.LoginInvitation' },
          { id: 2 - 2, value: false, label: 'UserModule.UsersData.LoginCredentialsUpdate' },
          { id: 2 - 3, value: false, label: 'UserModule.UsersData.PasswordReset' },
          { id: 2 - 3, value: false, label: 'UserModule.UsersData.NewPassword' },
          { id: 2 - 4, value: false, label: 'UserModule.UsersData.InvoiceNotification' },
          { id: 2 - 5, value: false, label: 'UserModule.UsersData.PaymentNotification' },
          { id: 2 - 6, value: false, label: 'UserModule.UsersData.Notice' },
          { id: 2 - 7, value: false, label: 'UserModule.UsersData.Custom' }
        ]
      },
      {
        id: 3,
        value: false,
        label: 'UserModule.UsersData.SMS',
        sub: [
          { id: 3 - 1, value: false, label: 'UserModule.UsersData.LoginInvitation' },
          { id: 3 - 2, value: false, label: 'UserModule.UsersData.InvoiceNotification' },
          { id: 3 - 3, value: false, label: 'UserModule.UsersData.AbsentNotification' },
          { id: 3 - 4, value: false, label: 'UserModule.UsersData.Custom' }
        ]
      },
      { id: 4, value: false, label: 'UserModule.UsersData.PrivateNote' },
      { id: 5, value: false, label: 'UserModule.UsersData.Profile' },
      { id: 6, value: false, label: 'UserModule.UsersData.Invoice' },
      { id: 7, value: false, label: 'UserModule.UsersData.Payment' },
      { id: 8, value: false, label: 'UserModule.UsersData.HealthRecord' }
    ];

    this.activities = [
      {
        type: 'Profile',
        typeText: 'UserModule.UsersData.Profile',
        date: new Date('Sat Sep 22 2018 16:42:40 GMT+0300'),
        activityText: 'UserModule.UsersData.YouCreateStudentProfile',
        comment: ''
      },
      {
        type: 'SMS',
        typeText: 'UserModule.UsersData.SMS',
        date: new Date('Sat Sep 22 2018 16:42:40 GMT+0300'),
        activityText: 'UserModule.UsersData.YouSentSMS',
        comment: ''
      },
      {
        type: 'PrivateNote',
        typeText: 'UserModule.UsersData.PrivateNote',
        date: new Date('Sat Sep 22 2018 16:42:40 GMT+0300'),
        activityText: 'UserModule.UsersData.YouSentPrivateNote',
        comment: 'Comment here'
      },
      {
        type: 'HealthRecord',
        typeText: 'UserModule.UsersData.HealthRecord',
        date: new Date('Sat Sep 22 2018 16:42:40 GMT+0300'),
        activityText: 'UserModule.UsersData.YouAddHealthRecordData',
        comment: 'Comment here'
      }
    ];
  }

  addNewReview(value) {
    console.log(value);
  }

  sendNewEmail(value) {
    console.log(value);
  }
  sendNewSMS(value) {
    console.log(value);
  }
  createPrivateNote(value) {
    console.log(value);
  }
}
